import { Box } from '@mui/material';
import * as S from '../Styled';
import { backgroundImage, logoImage } from '../../../../constants/Home/bannerImages';

const Banner = () => {
    return (
        <>
            <Box padding={0} margin={0} direction="column" >
                <S.BannerContainer backgroundImage={backgroundImage} >
                    <Box component="img" src={logoImage} alt="Logo"
                    sx={{ width: { xs: 200, md: 220 }}}
                    />
                    <S.TextsWrapper>
                        <h1>CRIE SEU CLUBE E OFEREÇA <strong>OS MELHORES</strong> BENEFÍCIOS</h1>
                        <h2>COM O <strong>MEUCUPOM CLUBES</strong></h2>
                    </S.TextsWrapper>
                </S.BannerContainer>
            </Box>
            <S.BannerMobile>
                <Box component="img" src={logoImage} alt="Logo"
                    sx={{ width: 200, margin: '0 auto',}}
                />
                <S.TextsWrapper>
                    <h1>
                    CRIE SEU CLUBE E OFEREÇA <strong>OS MELHORES</strong> BENEFÍCIOS
                    </h1>
                    <h2>
                    COM O <strong>MEUCUPOM CLUBES</strong>
                    </h2>
                </S.TextsWrapper>
            </S.BannerMobile>
        </>
    )
};
export default Banner;